import React, {useEffect, useState} from 'react';
import Result from './Result'
import FormWrapper from './form/FormWrapper';
import SelectField from './form/SelectField';
import NumberField from './form/NumberField';
import FormSubmit from './form/FormSubmit';

function NoiseCalculator() {
    const [stateValues, setStateValues] = useState({
        calculated: false,
        lrDay: null,
        lrNight: null,
        sensitivity: 2,
        valueType: 'pw',
        valid: false,
        scroll: 0,
    });
    useEffect(() => {
        if (stateValues.scroll) {
            document.querySelector('#laermberechnung-result').scrollIntoView({behavior: 'smooth'});
        }
    }, [stateValues.scroll]);
    const updateValue = (key) => (event) => {
        const formValid = event.target.form.checkValidity();
        const update = {
            ...stateValues,
            [key]: event.target.value,
            calculated: stateValues.submittedOnce && formValid,
            valid: formValid,
        };
        // if the result is currently shown, just update (but only if the form is valid)
        if (update.calculated) {
            updateCalculation(update);
        } else {
            setStateValues(update);
        }
    };
    const handleSubmit = () => {
        updateCalculation(stateValues, true);
    };
    const updateCalculation = (values, scrollToResults = false) => {
        const {lreDay, lreNight, distance} = values;
        if (lreDay && lreDay.length && lreNight && lreNight.length && distance && distance.length) {
            // we have all values to execute a calculation
            const lrDay = lreDay - 10 * Math.log10(distance);
            const lrNight = lreNight - 10 * Math.log10(distance);

            setStateValues({
                ...values,
                lrDay,
                lrNight,
                calculated: true,
                submittedOnce: true,
                scroll: scrollToResults ? stateValues.scroll + 1 : stateValues.scroll,
            });
        } else {
            // not all values are set
            setStateValues({
                ...values,
                lrDay: null,
                lrNight: null,
                calculated: false,
            });
        }
    };

    return (
        <article className={'box'}>
            <FormWrapper
                onSubmit={handleSubmit}
                legend='Berechnung Strassen- und Eisenbahnlärm'
            >
                <SelectField
                    label='Werte'
                    options={[
                        {label: 'Planungswert', value: 'pw'},
                        {label: 'Immissionsgrenzwert', value: 'igw'}
                    ]}
                    defaultValue={'pw'}
                    required
                    onChange={updateValue('valueType')}
                />
                <SelectField
                    label='Empfindlichkeitsstufe'
                    options={[
                        {label: 'II', value: '2'},
                        {label: 'III', value: '3'},
                        {label: 'IV', value: '4'}
                    ]}
                    defaultValue={2}
                    required
                    onChange={updateValue('sensitivity')}
                />
                <NumberField
                    label='Lre Tag'
                    required
                    min={0}
                    max={100000}
                    onChange={updateValue('lreDay')}
                />
                <NumberField
                    label='Lre Nacht'
                    required
                    min={0}
                    max={100000}
                    onChange={updateValue('lreNight')}
                />
                <NumberField
                    label='Abstand'
                    required
                    min={0}
                    max={100000}
                    onChange={updateValue('distance')}
                />
                <FormSubmit
                    name='absenden'
                    label='Absenden'
                    disabled={stateValues.valid === false}
                />
            </FormWrapper>
            {stateValues.calculated && (
                <Result
                    id='laermberechnung-result'
                    calculated={stateValues.calculated}
                    lrDay={stateValues.lrDay}
                    lrNight={stateValues.lrNight}
                    valueType={stateValues.valueType}
                    sensitivity={stateValues.sensitivity}
                    title='Berechnungsanzeige Strassen- und Eisenbahnlärm'
                />
            )}
        </article>
    );
}

export default NoiseCalculator;